import React, {useState, useEffect} from "react"
import PropTypes from "prop-types"
import {RouteComponentProps} from "react-router-dom"

import Loading from "@irati/ui/src/Loading"
import {hangPromise} from "@irati/utils/promise"
import dealService from "@irati/deals/services/deals"
import history from "@irati/utils/history"
import checkoutService from "@irati/checkout/services/checkout"
import redemptionFlow from "@irati/checkout/utils/redemption"
import detailsToWebAddress from "@irati/checkout/utils/redemption/helpers/detailsToWebAddress"
import DealByUrlSlug from "@irati/deals/apollo/query/DealByUrlSlug"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"
import {Card, Row, Col} from "@irati/ui/src/Layout"
import {H3} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"

import RequireDealStatusOn from "../../components/RequireDealStatusOn"
import DealBanner from "../../components/DealBanner"

interface Props extends RouteComponentProps<{urlSlug: string; checkoutId: string}>, WithPerkOrReward {}

const PaymentRedirectLanding: React.FC<Props> = ({isRewards, ...props}, context) => {
  const {urlSlug, checkoutId} = props.match.params
  const [load, setLoad] = useState(hangPromise())

  useEffect(() => {
    const request = dealService.getDealByUrlSlug({urlSlug}).then((deal) => {
      return checkoutService.getCheckout(checkoutId).then((checkout) => {
        return redemptionFlow.paymentComplete(deal, checkoutId, checkout.paymentOrder.uuid).then((details) => {
          const url = detailsToWebAddress(details)
          history.push(url, context)
          return hangPromise()
        })
      })
    })
    setLoad(request)
  }, [])

  return (
    <DealByUrlSlug variables={{urlSlug, isRewards}}>
      {({data}) => {
        if (!data || !data.dealBySlug) {
          return <RequireDealStatusOn deal={null} />
        }
        const deal = data.dealBySlug

        return (
          <>
            <DealBanner deal={deal} />
            <Row marginTop="75px">
              <Col mdOffset={3} md={6}>
                <Card padding={[4, 0, 2, 0]}>
                  <H3 textAlign="center">
                    <FormattedMessage id="perks.redemption.redirect.loading.copy" />
                  </H3>
                  <Loading load={load} />
                </Card>
              </Col>
            </Row>
          </>
        )
      }}
    </DealByUrlSlug>
  )
}

PaymentRedirectLanding.contextTypes = {
  appPath: PropTypes.string
}

export default withPerkOrReward(PaymentRedirectLanding)
